import { registerLicense } from "@syncfusion/ej2-base";

// Register Syncfusion license - this must be imported before any Syncfusion components
const syncfusionKey = import.meta.env.VITE_SYNCFUSION_API_KEY;

if (syncfusionKey) {
  registerLicense(syncfusionKey);
  console.log("✅ Syncfusion license registered successfully");
} else {
  console.error(
    "❌ Syncfusion license key is missing from environment variables"
  );
}
